(function (w) {
  var AssociatedProducts = function (id, widgetLink, requestData) {
    this.id = id;
    this.widgetLink = widgetLink;
    this.requestData = requestData;
  }

  AssociatedProducts.instances = {};
  AssociatedProducts.getInstance = function (id, widgetLink, requestData) {
    if (this.instances[id]) {
      return this.instances[id];
    } else {
      this.instances[id] = new this(id, widgetLink, requestData);

      return this.instances[id];
    }
  };

  AssociatedProducts.prototype = {
    init: function () {
      var self = this;

      this.$container = $('#' + this.id);

      if (!this.$container.length) {
        return;
      }

      self.trigger('onBeforeAjax');
      sendAjax(this.widgetLink, this.requestData, function (status, response) {
        self.trigger('onAfterAjax')
        if (status === 'OK') {
          const $parent = self.$container.parents('[data-view-block]').first();
          const tabId = $parent.attr('data-content-id');

          if (tabId) {
            const $tabButton = $(`[href="#${tabId}"]`);
            const hasSiblings = $tabButton.siblings().length;
            const $tabsParent = $tabButton.parent();

            if (response.products) {
              $(response.products).insertAfter(self.$container);
              $tabButton.find('.j-product-block-title').text(response.title);
              self.$container.remove();
              self.trigger('onAfterAppendHtml');
            } else {
              $parent.remove();
              $tabButton.remove();
              if (!hasSiblings) {
                $tabButton.parent('[data-view-block]').first().remove();
              }
            }
            if ($tabsParent && $tabsParent[0].tabs) {
              $tabsParent[0].tabs.destroy();
            }
            if (hasSiblings) {
              initTabs(`#${$tabsParent.attr('id')} a`, {
                activeClass: 'is-active',
                watchHash: true,
                onFirstShow() {
                  self.trigger('onTabChange');
                }
              });
            }
          } else {
            if (response.products) {
              $(response.products).insertAfter(self.$container);
              self.$container.parents('.j-product-block').find('.j-product-block-title').text(response.title);
              self.trigger('onAfterAppendHtml');
            } else {
              const $productBlock = self.$container.parents('.j-product-block');
              const $blockParent = $productBlock.parent();
              $productBlock.remove();
              if ($blockParent.length && !$blockParent.text().trim()) {
                $blockParent.remove();
              }
            }
            self.$container.remove();
          }
        }
      });
    }
  }

  Object.assign(AssociatedProducts.prototype, TMEvents);

  w.AssociatedProducts = AssociatedProducts;
})(window)
